export default __webpack_public_path__ + "static/media/UTMB.7ce768c8.svg";